"use client";

import { useMutation } from "@tanstack/react-query";
import log from "logbeacon";
import { safeStringifyError } from "utils";
import { useOspApiClientProvider } from "@/src/hooks";
import type {
  ChatClient,
  OnboardingCompleteResponse,
} from "@/src/features/api/ChatApi";
import { setEdgenOnboardingStepCookie } from "@/src/utils/onboarding";

/**
 * POST /onboarding/complete — 标记当前用户 Onboarding 流程已完成。
 */
export async function runCompleteOnboardingRequest(
  chatApi: ChatClient<unknown> | undefined,
): Promise<OnboardingCompleteResponse> {
  if (!chatApi?.onboarding?.completeCreate) {
    throw new Error("[useCompleteOnboarding] chatApi.onboarding unavailable");
  }

  const res = await chatApi.onboarding.completeCreate();
  if (res?.error) {
    log.warn(
      "[useCompleteOnboarding] complete failed",
      safeStringifyError(res.error),
    );
    throw res.error;
  }

  return res.data ?? {};
}

export const useCompleteOnboarding = () => {
  const { chatApi } = useOspApiClientProvider();

  return useMutation({
    mutationFn: async (): Promise<OnboardingCompleteResponse> => {
      log.info("[useCompleteOnboarding] complete request");
      return runCompleteOnboardingRequest(chatApi);
    },
    onSuccess: () => {
      setEdgenOnboardingStepCookie(3);
    },
  });
};
